module.exports = new __parcel__URL__("insights.8f48bf7d.svg").toString();